import React from "react";
import {useInjection} from "inversify-react";
import {observer} from "mobx-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {
    SecondaryButton,
    TrialButtons,
    TrialDescription,
    TrialIconWrapper,
    TrialNote,
    TrialSubcard,
    TrialTextGroup,
    TrialTitle,
    TrialTitleRow,
} from "./styled";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";

type Props = {
    trialDays: number;
    onTrial: () => void;
    onViewPlans: () => void;
}

const ExtensionTrialCard = observer(({trialDays, onTrial, onViewPlans}: Props) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    return (
        <TrialSubcard background={`${colors.accent}08`} border={`${colors.accent}20`}>
            <TrialTitleRow>
                <TrialIconWrapper background={`${colors.accent}20`} color={colors.accent}>
                    <DropDeskIcon icon={ICONS_DROPDESK.lastWeek} size={14} color={colors.accent}/>
                </TrialIconWrapper>
                <TrialTextGroup>
                    <TrialTitle color={colors.text}>
                        Experimente grátis por {trialDays} dias
                    </TrialTitle>
                    <TrialDescription color={colors.hint}>
                        Cancele quando quiser. Sem fidelidade.
                    </TrialDescription>
                </TrialTextGroup>
            </TrialTitleRow>
        </TrialSubcard>
    );
});

export default ExtensionTrialCard;
